(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ticket-status', {
            parent: 'entity',
            url: '/ticket-status',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.ticket_status.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ticket-status/ticket-statuses.html',
                    controller: 'Ticket_statusController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ticket_status');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('ticket-status-detail', {
            parent: 'entity',
            url: '/ticket-status/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.ticket_status.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ticket-status/ticket-status-detail.html',
                    controller: 'Ticket_statusDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ticket_status');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Ticket_status', function($stateParams, Ticket_status) {
                    return Ticket_status.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ticket-status',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ticket-status-detail.edit', {
            parent: 'ticket-status-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ticket-status/ticket-status-dialog.html',
                    controller: 'Ticket_statusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Ticket_status', function(Ticket_status) {
                            return Ticket_status.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ticket-status.new', {
            parent: 'ticket-status',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ticket-status/ticket-status-dialog.html',
                    controller: 'Ticket_statusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                status: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ticket-status', null, { reload: 'ticket-status' });
                }, function() {
                    $state.go('ticket-status');
                });
            }]
        })
        .state('ticket-status.edit', {
            parent: 'ticket-status',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ticket-status/ticket-status-dialog.html',
                    controller: 'Ticket_statusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Ticket_status', function(Ticket_status) {
                            return Ticket_status.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ticket-status', null, { reload: 'ticket-status' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ticket-status.delete', {
            parent: 'ticket-status',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ticket-status/ticket-status-delete-dialog.html',
                    controller: 'Ticket_statusDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Ticket_status', function(Ticket_status) {
                            return Ticket_status.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ticket-status', null, { reload: 'ticket-status' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
